__turbopack_context__.v({
  "costWithDiscount": "index-module-scss-module__8LbxAa__costWithDiscount",
  "strikePrice": "index-module-scss-module__8LbxAa__strikePrice",
});
